import React from 'react';
import './BookingStatusBar.css';
import { useLanguage } from './i18n/LanguageContext';

const BookingStatusBar = ({ bookingData, onClick }) => {
  const { t } = useLanguage();
  if (!bookingData) {
    return null;
  }

  const destination = bookingData?.endLocation || 
                     bookingData?.tripData?.dropDestination || 
                     bookingData?.dropDestination || 
                     'Destination';

  return (
    <div className="booking-status-bar" onClick={onClick}>
      <div className="status-bar-icon-container">
        <svg className="taxi-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="4" y="6" width="16" height="10" rx="1" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <rect x="6" y="8" width="12" height="6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <line x1="9" y1="8" x2="9" y2="14" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          <line x1="15" y1="8" x2="15" y2="14" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          <circle cx="7.5" cy="17.5" r="1.5" fill="currentColor"/>
          <circle cx="16.5" cy="17.5" r="1.5" fill="currentColor"/>
          <rect x="9" y="4" width="6" height="3" rx="0.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>
      <div className="status-bar-content">
        <p className="status-bar-primary-text">{t('Connecting you with a driver')}</p>
        <p className="status-bar-secondary-text">
          Destination : {destination.length > 30 ? `${destination.substring(0, 30)}...` : destination}
        </p>
      </div>
      <div className="status-bar-arrow-button">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>
    </div>
  );
};

export default BookingStatusBar;
